import { useNavigate } from "react-router-dom";
import React from "react";
import { Helmet } from "react-helmet";
import { MdLocationCity } from "react-icons/md";
import "./sitemap.css";

export const seo = {
  title: "Sitemap | Aooz - Technology, Digital Marketing, and Comparison Platform",
  description:
    "Explore Aooz’s sitemap: Access all our pages on technology, digital marketing, knowledge-based ads, comparison shopping, tools, and software solutions for businesses and users.",
  keywords:
    "Aooz sitemap, Aooz links, Aooz services, technology sitemap, digital marketing sitemap, e-commerce comparison sitemap, online tools sitemap",
  url: "https://aooz.in/sitemap",
  image: "https://aooz.in/assets/logo.png",
};

export default function Sitemap() {
  const navigate = useNavigate();

  const sitemapSections = [
    {
      title: "Main Pages",
      links: [
        { name: "Home", url: "/" },
        { name: "About Us", url: "/about" },
        { name: "Services", url: "/services" },
        { name: "Contact", url: "/contact" },
        { name: "Support", url: "/support" },
        { name: "Privacy Policy", url: "/privacy-policy" },
        { name: "Terms of Service", url: "/terms-and-conditions" },
      ],
    },
    {
      title: "Digital Marketing",
      links: [{ name: "SEO Optimization", url: "/product-seo" }],
    },
    {
      title: "Technology & Software",
      links: [{ name: "Web Development", url: "/software" }],
    },
    {
      title: "Knowledge-Based Ads",
      links: [
        { name: "Ad Platform Overview", url: "/platform" },
        { name: "Smart Targeting", url: "/smart-targeting" },
        { name: "Ad Analytics", url: "/analytics" },
        { name: "Business Integration", url: "/advertisement" },
      ],
    },
    {
      title: "Comparison Shopping",
      links: [
        { name: "Product Categories", url: "/compare" },
        { name: "Price Comparison", url: "/prices" },
        { name: "Top Rated Products", url: "/top-products" },
        { name: "Latest Deals", url: "/deals" },
      ],
    },
    {
      title: "Free Online Tools",
      links: [
        { name: "Word Counter", url: "/tools/word-counter" },
        { name: "Image to PDF", url: "/tools/image-to-pdf" },
        { name: "Favicon Generator", url: "/tools/favicon-generator" },
        { name: "SEO Analyzer", url: "/tools/seo-analyzer" },
        { name: "Text Utilities", url: "/tools/text-utilities" },
      ],
    },
    {
      title: "Affiliate & Partners",
      links: [
        { name: "Affiliate Program", url: "/affiliate" },
        { name: "Partner with Aooz", url: "/partner" },
      ],
    },
    {
      title: "Resources & Blog",
      links: [
        { name: "Tech Articles", url: "/blog/technology" },
        { name: "Digital Marketing Guides", url: "/blog/digital-marketing" },
        { name: "E-commerce Insights", url: "/blog/ecommerce" },
        { name: "Company News", url: "/blog/news" },
      ],
    },
  ];

  return (
    <div className="sitemap-page">
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:image" content={seo.image} />
        <meta property="og:url" content={seo.url} />
      </Helmet>

      <div className="sitemap-container">
        <div className="sitemap-header">
          <h1>🌐 Sitemap</h1>
          <p>
            Explore all sections of Aooz — from digital marketing and technology solutions
            to comparison shopping tools and business integrations.
          </p>
        </div>

        <div className="sitemap-grid">
          {sitemapSections.map((section, i) => (
            <div key={i} className="sitemap-card">
              <h3>
                <MdLocationCity className="icon" /> {section.title}
              </h3>
              <ul>
                {section.links.map((link, j) => (
                  <li key={j} onClick={() => navigate(link.url)}>
                    {link.name}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
